import { render, staticRenderFns } from "./settingDialog.vue?vue&type=template&id=3c7beac2&"
import script from "./settingDialog.vue?vue&type=script&lang=js&"
export * from "./settingDialog.vue?vue&type=script&lang=js&"
import style0 from "./settingDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports